import type { Strings } from "../state.js";
import { PhoneIcon, HangUpIcon } from "./icons.js";

export interface CallButtonProps {
  active: boolean;
  strings: Strings;
  onStart(): void;
  onStop(): void;
}

export function CallButton({ active, strings, onStart, onStop }: CallButtonProps) {
  return (
    <button
      type="button"
      class="va-call-button"
      data-active={String(active)}
      aria-label={active ? strings.endCall : strings.startCall}
      onClick={active ? onStop : onStart}
    >
      {active ? <HangUpIcon /> : <PhoneIcon />}
      <span class="va-call-label">{active ? strings.endCall : strings.startCall}</span>
    </button>
  );
}
